import React from 'react'

import { PriceString, ProfitString, SummaryModal } from '@fourthwall/components'
import { TimezonedDateString } from '@modules/Timezone/components/TimezonedDateString'

import type { Transaction } from '../../Transactions.types'
import { transactionTypeTexts } from '../../consts'

type TransactionSummaryModalProps = {
  transaction: Transaction
  onClose: () => void
}

export const TransactionSummaryModal = ({ transaction, onClose }: TransactionSummaryModalProps) => {
  const { value, balance, type, reason, transactionAt, principalName } = transaction

  return (
    <SummaryModal
      title="Transaction summary"
      items={[
        { label: 'Amount', content: <ProfitString value={value.value} /> },
        { label: 'Balance after transaction', content: <PriceString value={balance.value} /> },
        { label: 'Type of transaction', content: transactionTypeTexts[type] },
        { label: 'Description', content: reason },
        {
          label: 'Issue time',
          content: <TimezonedDateString date={transactionAt} format="h:mm A, MMM D, YYYY" />,
        },
        { label: 'Issuer', content: principalName },
      ]}
      onClose={onClose}
    />
  )
}
